export default __webpack_public_path__ + "static/media/termsOfUsPatients.0a1d0fb6.pdf";